module.exports = __webpack_public_path__ + "img/kar_yes.8b908a5e.png";